/// <reference path="../../../components/compare-manager.js" />
(function (ng) {
    function getUniqueKeys(products, propertySelector) {
        //build list of unique keys
        /// <summary>
        /// Gets the unique keys of a lookup property from the set of products given.
        /// </summary>
        /// <param name="products">The products.</param>
        /// <param name="propertySelector">The property selector.</param>
        /// <returns>Returns an array of sorted/unique keys</returns>
        var uniqueKeys = {};
        ng.forEach(products, function (product) {
            ng.extend(uniqueKeys, propertySelector(product));
        });

        //convert the unique properties to a sorted array
        var sortedKeys = [];
        ng.forEach(uniqueKeys, function (value, key) {
            sortedKeys.push(key);
        });
        sortedKeys.sort();

        return sortedKeys;
    }

    var app = new evo.CompareItems.App();

    ng.module('evo.Compare.Controllers').controller('compareController', ['$scope', '$document', '$timeout', 'comparableProductService',
        function ($scope, $document, $timeout, comparableProductService) {
            var self = this,
                loaded = {},
                model = {
                    _productIds: app.products,
                    loading: 0,
                    products: [],
                    filtered: false
                },
                removing = false;

            $scope.model = model;

            // Load the specified product and add it to the product list if it is not already loaded
            function loadProduct(compareId) {
                if (loaded[compareId])
                    return;
                loaded[compareId] = true;

                model.loading++;

                return comparableProductService.getComparableProduct(compareId).then(function (product) {
                    model.products.unshift(product);
                    model.loading--;
                }, function () {
                    model.loading--;
                    //remove bad product ids
                    console.warn('Removing invalid compare id: ' + compareId);
                    app.removeProduct(compareId);
                });
            };

            // Get an array containing the selected products
            function getSelectedProducts() {
                return (model.products || []).filter(function (p) { return p.selected; });
            }

            // Use $.ApplicationPath() to build an accurate url to the product
            self.buildProductUrl = function (relativePath) {
                return $.ApplicationPath() + relativePath;
            };

            // Iterate through the products to get all featureNames
            self.getAllFeatureNames = function () {
                return getUniqueKeys(model.products, function (product) { return product.Features; });
            };

            // Iterate through the products to get all specNames
            self.getAllSpecNames = function () {
                return getUniqueKeys(model.products, function (product) { return product.Specs; });
            };

            // Iterate through the products to get all matrixTypes
            self.getAllMatrixTypes = function () {
                return getUniqueKeys(model.products, function (product) { return product.Matrices; });
            };

            // Determine see if there are any selected products
            self.canFilter = function () {
                return !!getSelectedProducts().length;
            }

            // If we can filter, start filtering
            self.addFilter = function (filter) {
                if (self.canFilter()) {
                    model.filtered = true;
                }
            }

            // Stop filtering
            self.removeFilter = function () {
                model.filtered = false;
            }

            // Expose title and URL access methods
            self.getTitle = app.getTitle;
            self.getUrl = app.getUrl;

            // Remove all products
            self.removeAllProducts = function () {
                model.products = [];
                loaded = {};
                removing = true;
                app.removeAllProducts();
                removing = false;
            };

            // Remove the specified product from the product array
            self.removeProduct = function (productPageId) {
                delete loaded[productPageId];
                model.products = _.filter(model.products, function (p) {
                    return p.ProductPageId != productPageId;
                });
                app.removeProduct(productPageId);
            };
            
            //do a little initialization in case the user has come in from a shared compare link
            if (compareInput && compareInput.CompareIds && compareInput.CompareIds.length) {
                //don't use stored compare items and just load preset items
                ng.forEach(compareInput.CompareIds, loadProduct);

                if (compareInput.Title) {
                    app.setTitle(compareInput.Title);
                }

                if (compareInput.Url) {
                    app.setUrl(compareInput.Url);
                }
                return;
            }

            // Initialize the current products
            if (model._productIds && model._productIds.length) {
                ng.forEach(model._productIds, loadProduct);
            }
            else {
                model.loading = 0;
                // angular doesn't know it has to remove the existing classes
                ng.element('.loading').removeClass('loading');
            }

            // Watch for events fired by the compare 'app' when products are
            // added in other tabs / windows
            $document.on('productadded.evo.compare', function (ev, data) {
                if (!removing && data.fromStorage) {
                    loadProduct(data.id);
                    $scope.$apply();
                }
            });

            // Watch for events fired by the compare 'app' when products are
            // removed in other tabs / windows
            $document.on('productremoved.evo.compare', function (ev, data) {
                if (!removing && data.fromStorage) {
                    self.removeProduct(data.id);
                    $scope.$apply();
                }
            });
        }
    ]);
})(angular);